import type { AnchorHTMLAttributes } from 'react';
export default function Link({ href, prefetch, replace, scroll, ...props }: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string; prefetch?: boolean; replace?: boolean; scroll?: boolean }) {
  return <a href={href} {...props} />;
}
